import { useQuery } from '@apollo/client';

import { ANALYTICS_ADDITIONAL_MEASURES } from '../schemas/reports';

export const useChartAdditionalMeasures = ({ id, type }) => {
  const { data, loading } = useQuery(ANALYTICS_ADDITIONAL_MEASURES, {
    variables: {
      id,
      type,
    },
    fetchPolicy: 'network-only',
    skip: !id,
  });

  return {
    data: data?.dash8,
    loading,
  };
};
